<div class="popup-container">
	<h2>{{ countryName }}</h2>
	<p>Country Code: {{ countryCode }}</p>
</div>
